import { render } from "./button.vue?vue&type=template&id=a751c796"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__